import React from 'react';

const ShimmerBox = ({ className }) => <div className={`bg-gray-200 rounded ${className}`} />;

const StatsCardSkeleton = () => {
  return (
    <div className="relative bg-white p-4 rounded-xl border-2 border-gray-100 shadow-sm flex flex-col justify-between h-full min-h-[120px] overflow-hidden">
      <div className="animate-pulse">
        <div className="flex items-start justify-between mb-2">
          <ShimmerBox className="h-4 w-3/5" />
          <ShimmerBox className="w-5 h-5 rounded-md" />
        </div>
        <div className="flex-1 flex flex-col justify-end mt-4">
          <ShimmerBox className="h-8 w-1/3 mb-3" />
          <div className="flex items-center justify-between">
            <ShimmerBox className="h-3 w-2/5" />
            <ShimmerBox className="w-4 h-4 rounded-full" />
          </div>
        </div>
      </div>
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/80 to-transparent"></div>
    </div>
  );
};

export default StatsCardSkeleton;